import { DWELL_ACTIVATED, DWELL_BEGIN, DWELL_CANCELLED } from "Data/Topics";
import { Linear, Power4, Sine, TimelineMax, TweenLite  } from "gsap";
import * as HLF from "html-living-framework";
import * as Constants from "Data/Constants";

export class DwellCursor extends PIXI.Container {
    private readonly _g: PIXI.Graphics;
    private _tweenDwell: TimelineMax | undefined;
    private _animPerc: number;
    private _target: HLF.Input.IFocusable | undefined;

    constructor() {
        super();
        this._animPerc = 0;
        this._g = this.addChild(new PIXI.Graphics());
        this.hide(undefined, true);

        PubSub.subscribe(DWELL_BEGIN, (topic: string, data: HLF.Input.IFocusable) => this.show(data));
        PubSub.subscribe(DWELL_CANCELLED, (topic: string, data: HLF.Input.IFocusable) => this.hide());
        PubSub.subscribe(DWELL_ACTIVATED, (topic: string, data: HLF.Input.IFocusable) => this.hide(undefined, true));
    }

    public get target(): HLF.Input.IFocusable | undefined {
        return this._target;
    }

    private get animPerc(): number {
        return this._animPerc;
    }

    private set animPerc(pValue: number) {
        this._animPerc = pValue;
    }

    public show(pFocusable: HLF.Input.IFocusable): void {
        this.killTweens();

        this._target = pFocusable;
        this.redraw();
        this.visible = true;
        this._animPerc = 0;

        this._tweenDwell = new TimelineMax({
            repeat: 0,
            onUpdate: this.updateCorners.bind(this),
        });
        this._tweenDwell.to(this, Constants.DWELL_DURATION, {
            animPerc: 1,
            ease: Linear.easeNone,
        });
    }

    public hide(pOnComplete?: () => void, pInstantly: boolean = false): void {
        this.killTweens();
        this._target = undefined;
        this.visible = false;
        pOnComplete?.();
    }

    public redraw(): void {
        if (this._target !== undefined) {
            this.position.copyFrom(this.parent.worldTransform.applyInverse(this._target.getFocusPosition()));
            const size: PIXI.Point = this.parent.worldTransform.applyInverse(this._target.getFocusSize());
            this._g.clear();
            this._g.lineStyle(5, 0xfff7a6, 1, 1);
            this._g.drawRect(-size.x / 2, -size.y / 2, size.x, size.y);
        }
    }

    public destroy(pOptions?: Parameters<typeof PIXI.Container.prototype.destroy>[0]): void {
        this.killTweens();
        super.destroy(pOptions);
    }

    private killTweens(): void {
        if (this._tweenDwell !== undefined) {
            this._tweenDwell.kill();
        }
    }

    private updateCorners(): void {
        this._g.scale.set(HLF.MathUtils.lerp(1.25, 1, this._animPerc));
    }
}
